export const columns = [
  {
    title: "波次编号",
    dataIndex: "waveCode",
    key: "waveCode",
    width: 220,
    // scopedSlots: { customRender: "waveCode" }
  },
  {
    title: "国际发货单数",
    dataIndex: "orderAmount",
    key: "orderAmount",
    width: 120
  },
  {
    title: "批次数",
    dataIndex: "batchAmount",
    key: "batchAmount",
    width: 120
  },
  {
    title: "状态",
    dataIndex: "pickStatus",
    key: "pickStatus",
    customRender: text => {
      return text == 1 ? '已完成' : '未完成'
      // return {
      //   0: '正常',
      //   1: '撤销'
      // }[text];
    },
    width: 120
  },
  {
    title: "创建人",
    dataIndex: "creatorName",
    key: "creatorName"
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime"
  },
  {
    title: "操作",
    dataIndex: "actions",
    key: "actions",
    width: 150,
    fixed: 'right',
    scopedSlots: { customRender: "action" }
  },
];
export const pkgColumns = [
  {
    title: "拣货批次",
    dataIndex: "batchCode",
    key: "batchCode",
    scopedSlots: { customRender: "batchCode" }
  },
  {
    title: "商品数量",
    dataIndex: "productAmount",
    key: "productAmount",
    width: 120
  },
  {
    title: "库位数量",
    dataIndex: "gridAmount",
    key: "gridAmount",
    width: 120
  },
  {
    title: "状态",
    dataIndex: "batchStatus",
    key: "batchStatus",
    customRender: text => {
      return {
        0: '待领取',
        1: '待拣货',
        2: '拣货中',
        3: '拣货完成'
      }[text];
    },
    width: 120
  },
  {
    title: "拣货人",
    dataIndex: "operatorName",
    key: "operatorName"
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime"
  },
  {
    title: "拣货开始时间",
    dataIndex: "startTime",
    key: "startTime"
  },
  {
    title: "拣货结束时间",
    dataIndex: "finishTime",
    key: "finishTime"
  },
  {
    title: "操作",
    dataIndex: "actions",
    key: "actions",
    width: 150,
    fixed: 'right',
    scopedSlots: { customRender: "action" }
  },
]